import { render, staticRenderFns } from "./PackageReceiptSettings.vue?vue&type=template&id=6540b377&scoped=true"
import script from "./PackageReceiptSettings.vue?vue&type=script&lang=js"
export * from "./PackageReceiptSettings.vue?vue&type=script&lang=js"
import style0 from "./PackageReceiptSettings.vue?vue&type=style&index=0&id=6540b377&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6540b377",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6540b377')) {
      api.createRecord('6540b377', component.options)
    } else {
      api.reload('6540b377', component.options)
    }
    module.hot.accept("./PackageReceiptSettings.vue?vue&type=template&id=6540b377&scoped=true", function () {
      api.rerender('6540b377', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemSetting/setting/components/PackageReceiptSettings.vue"
export default component.exports